export enum BatchReportItemTypes {
  CUSTOM_REPORT = 'CR',
  REPORT = 'RP'
}

export const ARCHIVE_EXPORT = 'archive-export';
export const ARCHIVE_BASE_PATH = 'archive';
